import { Injectable } from '@angular/core';
import { ApiHttpService } from '../../../../_services/api-http.service';
import { environment } from '../../../../../environments/environment';
import {
  BehaviorSubject,
  catchError,
  map,
  Observable,
  of,
  Subject,
  throwError,
  timeout,
} from 'rxjs';
import { FormGroup } from '@angular/forms';
import { data } from 'jquery';
import { CustomerFilter } from '../../customers/customer-transaction-report/customer-transaction-report.component';
import { VelocityConfig } from '../../velocity-check/velocity-check.component';
import { CustomerListFilter } from '../../customers/customer-master/customer-master.component';
import { CustomerAlertFilter } from '../../customers/customer-approve/customer-approve.component';
import { CustomerBlockFilter } from '../../customers/customer-block/customer-block.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/_services/storage.service';
import { jwtDecode } from 'jwt-decode';

const {API_URL,API_URLBLAZE,API_URLPG,API_URLBLAZEOLD} = environment;
const {API_URL1} = environment;
// API_URLBLAZE = 'http://localhost:8082';
export interface RiskMerchantFilter {
  // "From"?: string,
  // "ToDate"?: string,
  // "Mid"?: string,
  // "RiskCode"?: string,
  // "RiskStage"?: string,
  // "RiskFlag"?: string
  // "Action"?: string
}

export interface MerchantFilter {
  columns?: any;
  name?: string;
  mid?: string;
  startDate?: string;
  endDate?: string;
  sendDate?: string;
  pageRecords?: number;
  pageNumber?: number;
  rid?: string;
  Status?: string;
  user_type?: string;
}

export interface AccountFilter {
  merchantid: string;
  pageRecords: number;
  pageNumber: number;
}

@Injectable({
  providedIn: 'root',
})
export class MerchantService {
  // @ts-ignore
  private node: Subject<Node> = new BehaviorSubject<Node>([]);
  mindatadis: boolean = true;
  loading: boolean = false;
  public kycUploadEvent = new Subject();
  public kycUploadObserver = this.kycUploadEvent.asObservable();

  constructor(
    private apiHttpService: ApiHttpService,
    private storageService: StorageService,
    private router: Router
  ) {
    // this.kycUploadEvent = new Subject();
    // this.kycUploadObserver = this.kycUploadEvent.asObservable();
  }

  get node$() {
    return this.node.asObservable();
  }

  uploadKycBrowseButton(data: any) {
    this.kycUploadEvent.next({
      type: 'FILE_LISTING',
      listData: data,
    });
  }

  kycFileUploadComplete(fileDetails: any) {
    this.kycUploadEvent.next({
      type: 'FILE_UPLOAD',
      fileData: fileDetails,
    });
  }

  kycFileDeleteEvent(fileDetails: any) {
    this.kycUploadEvent.next({
      type: 'FILE_DELETE',
      fileData: fileDetails,
    });
  }

  getAgentByName(data: any) {
    return this.apiHttpService.post(`${API_URL}/GetAgent`, data);
  }

  kycFileDownloadEvent(fileDetails: any) {
    this.kycUploadEvent.next({
      type: 'FILE_DOWNLOAD',
      fileData: fileDetails,
    });
  }

  kycFileViewEvent(fileDetails: any) {
    console.log('====>', this.kycUploadEvent);
    return this.kycUploadEvent.next({
      type: 'FILE_VIEWED',
      fileData: fileDetails,
    });
  }
  addNode(data: Node) {
    this.node.next(data);
  }

  createMerchant(data: any) {
    return this.apiHttpService.post(
      `${API_URLBLAZE}/user/merchant/onboarding`,
      {
        ...data,
      }
    );
  }

  private normalizeLookupId(value: any): number | null {
    if (value === null || value === undefined || value === '') return null;
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed <= 0) return null;
    return parsed;
  }

  private resolveMerchantLookupId(explicitId?: number | string | null): number | null {
    const explicit = this.normalizeLookupId(explicitId);
    if (explicit) return explicit;

    const user = this.storageService.getUser() || {};
    const userCandidates = [
      user.bankCode,
      user.bank_code,
      user.bankId,
      user.bank_id,
      user.id,
      user.userId,
      user.entityId,
    ];
    for (const candidate of userCandidates) {
      const normalized = this.normalizeLookupId(candidate);
      if (normalized) return normalized;
    }

    const token = this.storageService.getToken();
    if (token) {
      try {
        const payload: any = jwtDecode(token);
        const tokenCandidates = [
          payload.bankCode,
          payload.bank_code,
          payload.bankId,
          payload.bank_id,
          payload.id,
          payload.userId,
          payload.entityId,
        ];
        for (const candidate of tokenCandidates) {
          const normalized = this.normalizeLookupId(candidate);
          if (normalized) return normalized;
        }
      } catch (_e) {
        // Ignore decode failures and use legacy fallback endpoints.
      }
    }

    return null;
  }

  getLicenseTypes(id?: number | string | null) {
    const lookupId = this.resolveMerchantLookupId(id);
    if (lookupId) {
      return this.apiHttpService.get(`${API_URLBLAZE}/user/merchant/merchant-license-type?id=${lookupId}`);
    }
    return this.apiHttpService.get(`${API_URLBLAZE}/user/merchant/license-type`);
  }

  getVolumeRanges() {
    return this.apiHttpService.get(`${API_URLBLAZE}/user/merchant/volume-range`);
  }

  getBanks(id?: number | string | null) {
    const lookupId = this.resolveMerchantLookupId(id);
    if (lookupId) {
      return this.apiHttpService.get(`${API_URLBLAZE}/user/merchant/merchant-moroccan-bank?id=${lookupId}`);
    }
    return this.apiHttpService.get(`${API_URLBLAZE}/user/merchant/moroccan-bank`);
  }

  // Create Reseller
  createReseller(data: any) {
    return this.apiHttpService.post(
      // `${API_URL}/create-merchant`,
      `${API_URLBLAZE}/user/reseller/onboarding`,
      // `http://localhost:8082/user/reseller/onboarding`,
      {
        ...data,
      }
    );
  }

  getdownload(url: string, data: any) {
    return this.apiHttpService.post(url, data);
  }

  getMerchant(id: any) {
    //  alert(id);
    return (
      this.apiHttpService
        // .post(`${API_URL}/MerchantCreationDetails`,
        //   {
        //     "Mid": id
        //   })

        .get(`${API_URLBLAZE}/user/merchant/getMerchant?userId=${id}`,
          // .get(`http://localhost:8082/merchant/getMerchant?userId=${id}`,
          {
            Mid: id,
          }
        )
    );
  }


    getReseller(id: any) {
    debugger;
    //  alert(id);
    return (
      this.apiHttpService
        // .post(`${API_URL}/MerchantCreationDetails`,
        //   {
        //     "Mid": id
        //   })

        .get(`${API_URLBLAZE}/user/reseller/getReseller?userId=${id}`,
          // .get(`http://localhost:8082/user/reseller/getReseller?userId=${id}`,
          {
            Mid: id,
          }
        )
    );
  }


  getRiskData(
    id: any,
    subid: any,
    riskcode: any,
    pageSize: number = 10,
    page: number = 1
  ) {
    debugger;

    if (id && subid && riskcode) {
      // alert(id + "-"+ subid +"-" + riskcode)
      return this.apiHttpService.post(
        `${API_URL}/getBusinessDetails/${id}/${subid}/${riskcode}?pageSize=${pageSize}&page=${page}`,
        null
      );
    }
    if (id && subid && riskcode == null) {
      return this.apiHttpService.post(
        `${API_URL}/getBusinessDetails/${id}/${subid}?pageSize=${pageSize}&page=${page}`,
        null
      );
    }
    if (id && subid == null && riskcode == null) {
      return this.apiHttpService.post(
        `${API_URL}/getBusinessDetails/${id}?pageSize=${pageSize}&page=${page}`,
        null
      );
    }
    if (riskcode != null && id == null && subid == null) {
      return this.apiHttpService.post(
        `${API_URL}/getBusinessDetailsRisk/${riskcode}?pageSize=${pageSize}&page=${page}`,
        null
      );
    }
    if (id != null && subid == null && riskcode != null) {
      return this.apiHttpService.post(
        `${API_URL}/getBusinessDetailsRiskCat/${id}/${riskcode}?pageSize=${pageSize}&page=${page}`,
        null
      );
    }
    return this.apiHttpService.post(
      `${API_URL}/getBusinessDetails?pageSize=${pageSize}&page=${page}`,
      null
    );
  }

  getSummaryReportData(
    riskScore: any,
    merchantID: any,
    bussinessCategory: any,
    subBussinessCategory: any,
    bussinesstype: any,
    pageSize: number = 10,
    page: number = 1
  ) {
    debugger;

    let baseUrl: any = '';
    if (riskScore != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&riskScore=' + riskScore;
      } else {
        baseUrl = baseUrl + '?riskScore=' + riskScore;
      }
    }

    if (merchantID != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&merchantID=' + merchantID;
      } else {
        baseUrl = baseUrl + '?merchantID=' + merchantID;
      }
    }

    if (bussinessCategory != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&bussinessCategory=' + bussinessCategory;
      } else {
        baseUrl = baseUrl + '?bussinessCategory=' + bussinessCategory;
      }
    }
    if (subBussinessCategory != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&subBussinessCategory=' + subBussinessCategory;
      } else {
        baseUrl = baseUrl + '?subBussinessCategory=' + subBussinessCategory;
      }
    }

    if (bussinesstype != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&bussinesstype=' + bussinesstype;
      } else {
        baseUrl = baseUrl + '?bussinesstype=' + bussinesstype;
      }
    }
    if (
      bussinesstype == '' &&
      subBussinessCategory == '' &&
      bussinessCategory == '' &&
      merchantID == '' &&
      riskScore == ''
    ) {
      baseUrl = '';
    }
    return this.apiHttpService.post(
      `${API_URL}/GetMerchantsummery/all/filter/${page}/${pageSize}${baseUrl}`,
      null
    );
  }

  downloadSummaryReportData(
    riskScore: any,
    merchantID: any,
    bussinessCategory: any,
    subBussinessCategory: any,
    bussinesstype: any
  ) {
    debugger;

    let baseUrl: any = '';
    if (riskScore != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&riskScore=' + riskScore;
      } else {
        baseUrl = baseUrl + '?riskScore=' + riskScore;
      }
    }

    if (merchantID != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&merchantID=' + merchantID;
      } else {
        baseUrl = baseUrl + '?merchantID=' + merchantID;
      }
    }

    if (bussinessCategory != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&bussinessCategory=' + bussinessCategory;
      } else {
        baseUrl = baseUrl + '?bussinessCategory=' + bussinessCategory;
      }
    }
    if (subBussinessCategory != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&subBussinessCategory=' + subBussinessCategory;
      } else {
        baseUrl = baseUrl + '?subBussinessCategory=' + subBussinessCategory;
      }
    }

    if (bussinesstype != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&bussinesstype=' + bussinesstype;
      } else {
        baseUrl = baseUrl + '?bussinesstype=' + bussinesstype;
      }
    }
    if (
      bussinesstype == '' &&
      subBussinessCategory == '' &&
      bussinessCategory == '' &&
      merchantID == '' &&
      riskScore == ''
    ) {
      baseUrl = '';
    }
    return this.apiHttpService.post(
      `${API_URL}/summery/filter/download/${baseUrl}`,
      null
    );
  }
  getNegativeReportData(
    riskScore: any,
    merchantID: any,
    bussinessCategory: any,
    subBussinessCategory: any,
    bussinesstype: any,
    legalName: any,
    pageSize: number = 10,
    page: number = 1
  ) {
    debugger;
    //   merchantID=2318403521&riskScore=1&bussinessCa[…]ry=0&subBussinessCategory&bussinesstype=1&legalName=Dreseller
    let baseUrl: any = '';
    if (riskScore != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&riskScore=' + riskScore;
      } else {
        baseUrl = baseUrl + '?riskScore=' + riskScore;
      }
    }

    if (merchantID != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&merchantID=' + merchantID;
      } else {
        baseUrl = baseUrl + '?merchantID=' + merchantID;
      }
    }

    if (bussinessCategory != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&bussinessCategory=' + bussinessCategory;
      } else {
        baseUrl = baseUrl + '?bussinessCategory=' + bussinessCategory;
      }
    }
    if (subBussinessCategory != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&subBussinessCategory=' + subBussinessCategory;
      } else {
        baseUrl = baseUrl + '?subBussinessCategory=' + subBussinessCategory;
      }
    }

    if (bussinesstype != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&bussinesstype=' + bussinesstype;
      } else {
        baseUrl = baseUrl + '?bussinesstype=' + bussinesstype;
      }
    }
    if (legalName != '') {
      if (baseUrl.includes('?')) {
        baseUrl = baseUrl + '&legalName=' + legalName;
      } else {
        baseUrl = baseUrl + '?legalName=' + legalName;
      }
    }
    if (
      bussinesstype == '' &&
      subBussinessCategory == '' &&
      bussinessCategory == '' &&
      merchantID == '' &&
      riskScore == '' &&
      legalName == ''
    ) {
      baseUrl = '';
    }
    return this.apiHttpService.post(
      `${API_URL}/merchants/${page}/${pageSize}${baseUrl}`,
      null
    );
  }

  getDocumentList(merid: any, pageSize: number = 10, page: number = 1) {
    return this.apiHttpService.post(
      `${API_URL}/kycDocs/${merid}?pageSize=${pageSize}&page=${page}`,
      null
    );
  }

  getAllMerchant(
    pageSize: number = 10,
    page: number = 0,
    filter?: MerchantFilter
  ) {
    // alert(JSON.stringify(filter))
    return this.apiHttpService.post(
      `${API_URL}/get-all?pageSize=${pageSize}&page=${page}`,
      {
        name: filter?.name || '',
        mid: filter?.mid || '',
        rid: filter?.rid || '',
        Status: filter?.Status || '',
        startDate: filter?.startDate || '',
        endDate: filter?.endDate || '',
        sendDate: filter?.sendDate || '',
        pageRecords: pageSize || 10,
        pageNumber: page || 0,
        //"user_type":filter?.user_type||"NULL"
      }
    );
  }

  //Get Merchant/Agent/SubAgent List
  getMerchantAgentList(
    fullName: String,
    mobileNumber: String,
    dateFrom: string,
    dateTo: String,
    page_size: number,
    page_no: number
  ) {
    var url = '';
    var filter = '';
    if (fullName != '' && fullName != undefined) {
      filter = filter + `&fullName=${fullName}`;
    }
    if (mobileNumber != '' && mobileNumber != undefined) {
      filter = filter + `&mobileNumber=${mobileNumber}`;
    }
    filter = filter + `&kycStatus=in$Successful`;
    filter = filter + `&status=in$NEW`;

    url =
      `${API_URLBLAZE}/user/customer/customerList?page_size=${page_size}&page_no=${page_no}&userType=AGENT` +
      filter;
    // url = `${API_URLBLAZE}/user/customer/customerList?page_size=${page_size}&page_no=${page_no}&userType=AGENT`+filter;

    console.log(url);
    return this.apiHttpService.get(url).pipe(catchError(this.handleError()));
  }

  getAllCustomer(
    pageSize: number = 10,
    page: number = 0,
    filter?: CustomerAlertFilter
  ) {
    // alert(JSON.stringify(filter))
    return this.apiHttpService.post(
      `${API_URL}/get-customer?pageSize=${pageSize}&page=${page}`,
      {
        name: filter?.fullname || '',
        mobile: filter?.mobile || '',
        emailId: filter?.emailId || '',
        Status: filter?.Status || '',
        startDate: filter?.startDate || '',
        endDate: filter?.endDate || '',
        pageRecords: pageSize || 10,
        pageNumber: page || 0,
        kycStatus: filter?.KycStatus || '',
      }
    );
  }

  getAllCustomerBlocked(
    pageSize: number = 10,
    page: number = 0,
    filter?: CustomerBlockFilter
  ) {
    // alert(JSON.stringify(filter))
    return this.apiHttpService.post(
      `${API_URL}/get-customerBlocked?pageSize=${pageSize}&page=${page}`,
      {
        name: filter?.fullname || '',
        mobile: filter?.mobile || '',
        emailId: filter?.emailId || '',
        Status: filter?.Status || '',
        startDate: filter?.startDate || '',
        endDate: filter?.endDate || '',
        pageRecords: pageSize || 10,
        pageNumber: page || 0,
        kycStatus: filter?.KycStatus || '',
      }
    );
  }

  getAllUtilityScreening(
    pageSize: number = 10,
    page: number = 0,
    filter?: MerchantFilter
  ) {
    // alert(JSON.stringify(filter))
    return this.apiHttpService.post(
      `${API_URL}/get-utilityScreening?pageSize=${pageSize}&page=${page}`,
      {
        name: filter?.name || '',
        mid: filter?.mid || '',
        Status: filter?.Status || '',
        startDate: filter?.startDate || '',
        endDate: filter?.endDate || '',
        sendDate: filter?.sendDate || '',
        pageRecords: pageSize || 10,
        pageNumber: page || 0,
        //"user_type":filter?.user_type||"NULL"
      }
    );
  }

  getApprovedCustomer(
    pageSize: number = 10,
    page: number = 0,
    filter?: CustomerListFilter
  ) {
    // alert(JSON.stringify(filter))
    return this.apiHttpService.post(
      `${API_URL}/get-approvedCustomer?pageSize=${pageSize}&page=${page}`,
      {
        name: filter?.fullname || '',
        mobile: filter?.mobile || '',
        emailId: filter?.emailId || '',
        Status: filter?.Status || '',
        startDate: filter?.startDate || '',
        endDate: filter?.endDate || '',
        pageRecords: pageSize || 10,
        pageNumber: page || 0,
        kycStatus: filter?.KycStatus || '',
      }
    );
  }

  getCustomerTransactionReport(
    pageSize: number,
    page: number,
    filter?: CustomerFilter
  ) {
    return this.apiHttpService.post(`${API_URL}/customerTransactionReport`, {
      dateFrom: filter?.dateFrom,
      dateTo: filter?.dateTo,
      orderId: filter?.orderId,
      customerMobile: filter?.customerMobile,
      totalAmount: filter?.totalAmount,
      txnType: filter?.transactionType,
      status: filter?.status,
    });
  }

  getCustomerWalletLedgerReport(
    pageSize: number = 10,
    page: number = 0,
    filter?: CustomerFilter
  ) {
    return this.apiHttpService.post(`${API_URL}/customerWalletLedger`, {
      dateFrom: filter?.dateFrom,
      dateTo: filter?.dateTo,
      customerMobile: filter?.customerMobile,
      txnType: filter?.transactionType,
    });
  }

  getCustomerReconciliationReport(mobile: any, date: any) {
    return this.apiHttpService.get(
      `${API_URL}/customerReconciliationReport?mobile=` +
        mobile +
        '&date=' +
        date
    );
  }

  getReconciliationReport(date: any) {
    return this.apiHttpService.get(
      `${API_URL}/reconciliationReport?date=` + date
    );
  }

  getAgentReconciliationReport(mobile: any, date: any) {
    return this.apiHttpService.get(
      `${API_URL}/agentReconciliationReport?mobile=` + mobile + '&date=' + date
    );
  }

  getReviewStatusFlag(mobile: any) {
    return this.apiHttpService.get(`${API_URL}/getReviewFlag?mobile=` + mobile);
  }

  getIdenfoFullResponse(mobile: any) {
    return this.apiHttpService.post(
      `${API_URL}/idenfoDataForHtml?mobile=${mobile}`,
      {}
    );
  }

  getIdenfoFullResponseForScreeningUtility(idenfoId: any) {
    return this.apiHttpService.post(
      `${API_URL}/idenfoDataForScreeningUtility?idenfoId=${idenfoId}`,
      {}
    );
  }

  // getBusinessType() {
  //   return this.apiHttpService
  //     .post(
  //       `${API_URL}/GetDropdown`,
  //       {
  //         "Type": "1",
  //         "Value": ""
  //       }
  //     )
  // }

  getBusinessType() {
    return (
      this.apiHttpService
        .get(`${API_URLBLAZE}/user/common/get-business-type`)
        //.get(`http://localhost:8082/user/common/get-business-type`)

        .pipe(
          map((data: any[]) =>
            data.map((item) => ({
              ...item,
              FieldValue: Number(item.FieldValue), // Convert to number
            }))
          )
        )
    );
  }

  subCategoryType(data: any) {
    return this.apiHttpService.post(`${API_URL}/GetDropdown`, data);
  }

  getMerchantCategory() {
    return this.apiHttpService.post(`${API_URL}/GetDropdown`, {
      Type: '2',
      Value: '',
    });
  }

  //Get Merchant List with Pagination
  getMerchantList(
    mid: String,
    mobile: String,
    fullName: String,
    emailId: String,
    status: String,
    kycStatus: String,
    tradeNumber: String,
    filterData: MerchantFilter,
    page_size: any,
    page_no: number
  ) {
    var url = '';
    var filter = '';
    if (mid != '' && mid != undefined) {
      filter = filter + `&identifier=${mid}`;
    }
    if (mobile != '' && mobile != undefined) {
      filter = filter + `&mobileNumber=${mobile}`;
    }
    if (fullName != '' && fullName != undefined) {
      filter = filter + `&firstName=${fullName}`;
    }
    if (emailId != '' && emailId != undefined) {
      filter = filter + `&emailId=${emailId}`;
    }
    if (tradeNumber != '' && tradeNumber != undefined) {
      filter = filter + `&commercialLicense=${tradeNumber}`;
    }
    if (kycStatus != '' && kycStatus != null) {
      filter = filter + `&kycStatus=$in=${kycStatus}`;
    } else {
      // filter = filter+`&kycStatus=$in=New,Inprocess,Successful,Rejected,Potential Hit`
    }
    if (status != '' && status != null) {
      filter = filter + `&status=$in=${status}`;
    }
    if (filterData.rid != '' && filterData.rid != null) {
      filter = filter + `&parent.id=${filterData.rid}`;
    }
    if (
      filterData.startDate != '' &&
      filterData.startDate != undefined &&
      filterData.endDate != '' &&
      filterData.endDate != undefined
    ) {
      filter =
        filter +
        `&createdDate=$gte=${filterData.startDate} 00:00:00$lte=${filterData.endDate} 23:59:59`;
    }
    filter = filter + `&sort_dir=DESC`;
    filter = filter + `&sort_column=createdDate`;

    url =
      `${API_URLBLAZE}/user/merchant/merchantList?page_size=${page_size}&page_no=${page_no}&userType=$in=MERCHANT,AGENT` +
      filter;
    //  url = `http://localhost:8082/user/merchant/merchantList?page_size=${page_size}&page_no=${page_no}&userType=$in=MERCHANT,AGENT`+filter;

    console.log(url);
    return this.apiHttpService.get(url).pipe(catchError(this.handleError()));
  }

  getBlockedMerchantList(
    mid: String,
    mobile: String,
    fullName: String,
    emailId: String,
    status: String,
    kycStatus: String,
    tradeNumber: String,
    filterData: MerchantFilter,
    page_size: any,
    page_no: number,
    id?: String
  ) {
    var url = '';
    var filter = '';
    if (id) {
      filter = filter + `&id=$in=${id}`;
    }

    if (mid != '' && mid != undefined) {
      filter = filter + `&identifier=${mid}`;
    }
    if (mobile != '' && mobile != undefined) {
      filter = filter + `&mobileNumber=${mobile}`;
    }
    if (fullName != '' && fullName != undefined) {
      filter = filter + `&firstName=${fullName}`;
    }
    if (emailId != '' && emailId != undefined) {
      filter = filter + `&emailId=${emailId}`;
    }
    if (tradeNumber != '' && tradeNumber != undefined) {
      filter = filter + `&commercialLicense=${tradeNumber}`;
    }
    if (kycStatus != '' && kycStatus != null) {
      filter = filter + `&kycStatus=$in=${kycStatus}`;
    } else {
      // filter = filter+`&kycStatus=$in=New,Inprocess,Successful,Rejected,Potential Hit`
    }
    if (status != '' && status != null) {
      filter = filter + `&status=$in=${status}`;
    }
    if (filterData.rid != '' && filterData.rid != null) {
      filter = filter + `&parent.id=${filterData.rid}`;
    }
    if (
      filterData.startDate != '' &&
      filterData.startDate != undefined &&
      filterData.endDate != '' &&
      filterData.endDate != undefined
    ) {
      filter =
        filter +
        `&createdDate=$gte=${filterData.startDate} 00:00:00$lte=${filterData.endDate} 23:59:59`;
    }
    filter = filter + `&status=$in=BLOCKED`;

    filter = filter + `&sort_dir=DESC`;
    filter = filter + `&sort_column=createdDate`;

    url =
      `${API_URLBLAZE}/user/merchant/merchantList?page_size=${page_size}&page_no=${page_no}&userType=$in=MERCHANT,AGENT` +
      filter;
    //  url = `http://localhost:8082/user/merchant/merchantList?page_size=${page_size}&page_no=${page_no}&userType=$in=MERCHANT,AGENT`+filter;

    console.log(url);
    return this.apiHttpService.get(url).pipe(catchError(this.handleError()));
  }

  sendPOSRequest(id: any) {
    return this.apiHttpService.post(
      `${API_URLBLAZE}/user/merchant/posOnboarding?userId=${id}`,
      {}
    );
    // `http://localhost:8082/user/merchant/posOnboarding?userId=${id}`,{})
  }

  unregisterClient(mobileNumber: string) {
    return this.apiHttpService.post(`${API_URLBLAZE}/user/data/delete-user`, {
      mobileNumber,
    });
  }

  getMerchantSubCategory(categoryId: any) {
    return this.apiHttpService.post(`${API_URL}/GetDropdown`, {
      Type: '19',
      Value: categoryId,
    });
  }

  // getInstrumentMaster() {
  //   return this.apiHttpService
  //     .post(
  //       `${API_URL}/GetDropdown`,
  //       {
  //         "Type": "3",
  //         "Value": ""
  //       }
  //     )
  // }

  getInstrumentMaster() {
    return this.apiHttpService.get(
      `${API_URLBLAZE}/user/common/get-payment-instruments`
      //`http://localhost:8082/user/common/get-payment-instruments`
    );
  }

  validate(data: any) {
    return this.apiHttpService.post(`${API_URL}/pennyDrop`, data);
  }

  customerStatusApprove(mobile: any) {
    return this.apiHttpService.post(
      `${API_URL}/status-approve?mobile=${mobile}`,
      {}
    );
  }
  customerStatusReject(mobile: any) {
    return this.apiHttpService.post(
      `${API_URL}/status-reject?mobile=${mobile}`,
      {}
    );
  }

  customerStatusChangeFinal(mobile: any, status: any) {
    return this.apiHttpService.post(
      `${API_URL}/customer-status-change?mobile=${mobile}&status=${status}`,
      {}
    );
  }

  merchantStatusChange(statusChangeRequest:any){
    const url = `${API_URLBLAZE}/user/merchant/merchantStatus`;
    return this.apiHttpService.post(url, statusChangeRequest).pipe(catchError(this.handleError()));
  }

  resellerStatusChange(statusChangeRequest:any){
    const url = `${API_URLBLAZE}/user/reseller/resellerStatus`;
    return this.apiHttpService.post(url, statusChangeRequest).pipe(catchError(this.handleError()));
  }

  viewCustomerReport(mobile: any) {
    return this.apiHttpService.post(
      `${API_URL}/idenfo?mobile=${mobile}`,
      {},
      {
        observe: 'response',
        responseType: 'blob',
      }
    );
  }

  viewCustomerReportHtml(mobile: any) {
    return this.apiHttpService.get(`${API_URL}/idenfo/html?mobile=${mobile}`, {
      observe: 'response',
      responseType: 'text',
    });
  }

  viewCustomerReportImage(mobile: any) {
    return this.apiHttpService.get(
      `${API_URL}/emirates/image?mobile=${mobile}`,
      {
        observe: 'response',
        responseType: 'text',
      }
    );
  }

  viewEdcData(mobile: any) {
    return this.apiHttpService.get(
      `${API_URL}/getEdcData?mobile=${mobile}`,
      {}
    );
  }

  viewScreeningUtilityData(idenfoId: any) {
    return this.apiHttpService.get(
      `${API_URL}/getScreeningUtilityData?idenfoId=${idenfoId}`,
      {}
    );
  }

  getActivityTimelineData(idenfoId: any, fullname: any) {
    return this.apiHttpService.get(
      `${API_URL}/getActivityTimeline?idenfoId=${idenfoId}&fullname=${fullname}`,
      {}
    );
  }

  getNameScreeningRemark(idenfoId: any) {
    return this.apiHttpService.get(
      `${API_URL}/getNameScreeningRemark?idenfoId=${idenfoId}`,
      {}
    );
  }

  saveActivityTimeline(
    idenfoId: any,
    fullname: any,
    narration: any,
    type: any,
    addedBy: any
  ) {
    return this.apiHttpService.post(`${API_URL}/addActivityTimeline`, {
      idenfoId: idenfoId,
      fullname: fullname,
      narration: narration,
      type: type,
      addedBy: addedBy,
    });
  }

  saveNameScreeningRemark(
    idenfoId: any,
    referenceId: any,
    remark: any,
    relavancy: any,
    mobile: any
  ) {
    return this.apiHttpService.post(`${API_URL}/addNameScreeningRemark`, {
      idenfoId: idenfoId,
      referenceId: referenceId,
      remarks: remark,
      relevancy: relavancy,
      mobile: mobile,
    });
  }

  updateReviewFlag(reviewFlag: String, mobile: any, addedBy: String) {
    return this.apiHttpService.post(
      `${API_URL}/updateReviewFlag?reviewFlag=${reviewFlag}&mobile=${mobile}&addedBy=${addedBy}`,
      {}
    );
  }

  createScreeningUtility(data: any) {
    return this.apiHttpService.post(
      `${API_URL}/generateScreeningRequestUtility`,
      {
        fullname: data.fullname,
        nationality: data.nationality,
        dob: data.dateOfBirth,
        gender: data.gender,
        emailId: data.emailId,
        countryOfResidence: data.countryOfResidence,
        emiratesId: data.emiratesId,
        emiratesExpiry: data.emiratesExpiry,
        passportNumber: data.passportNumber,
        passportExpiry: data.passportExpiry,
        state: data.state,
        city: data.city,
        address: data.address,
        zipCode: data.poBox,
        contactNumber: data.contactNumber,
      }
    );
  }

  getVelocityConfig(id: any) {
    return this.apiHttpService.getRaw(`${API_URL}/transaction/velocity/getVelocityRule?id=${id}`, {}).pipe(
      timeout(30000), // 30 second timeout for faster error detection
      catchError((error) => {
        console.error('getVelocityConfig error:', error);
        if (error.name === 'TimeoutError') {
          return throwError(() => ({ status: 0, name: 'TimeoutError', message: 'Request timed out' }));
        }
        return throwError(() => error);
      })
    );
  }

  saveVelocityConfig(velocityConfig: VelocityConfig) {
    return this.apiHttpService.postRaw(
      //`${API_URL}/saveVelocityRule`,
      `${API_URL}/transaction/velocity/saveVelocityRuleShield`,
      velocityConfig
    ).pipe(
      timeout(30000), // 30 second timeout
      catchError((error) => {
        console.error('saveVelocityConfig error:', error);
        return throwError(() => error);
      })
    );
  }

  getVelocityName(mobile: any, userType: any) {
    return this.apiHttpService.get(
      `${API_URL}/getVelocityMobile?mobile=${mobile}&userType=${userType}`,
      {}
    );
  }

  downloadPdf(data: any) {
    alert('data===' + data);
    if (data) {
      const linkSource = 'data:application/octet-stream;base64,' + data.text;
      const downloadLink = document.createElement('a');
      const fileName = 'Merchant_' + '.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.loading = false;
    } else {
      this.mindatadis = false;
      this.loading = false;
    }
  }

  // getResellerList() {
  //   return this.apiHttpService
  //     .post(
  //       `${API_URL}/GetDropdown`,
  //       {
  //         "Type": "4",
  //         "Value": ""
  //       }
  //     )
  // }

  getResellerList() {
    return this.apiHttpService.post(`${API_URL}/GetDropdown`, {
      Type: '31',
      Value: '',
    });
  }

  getMerchantStatus() {
    return this.apiHttpService.post(`${API_URL}/GetDropdown`, {
      Type: '8',
      Value: 'merchant_status',
    });
  }

  //MDR Setup
  getServiceProvider() {
    const reqData = {
      Type: '5',
      Value: '',
    };
    return this.apiHttpService.post(`${API_URL}/GetDropdown`, reqData);
  }

  getService(spId?: any) {
    const reqData = {
      Type: '6',
      Value: spId || '',
    };
    return this.apiHttpService.post(`${API_URL}/GetDropdown`, reqData);
  }

  getInstruments(serId?: any) {
    const reqData = {
      Type: '7',
      Value: serId || '',
    };
    return this.apiHttpService.post(`${API_URL}/GetDropdown`, reqData);
  }

  getInstrumentBrand() {
    const reqData = {
      Type: '14',
      Value: '',
    };
    return this.apiHttpService.post(`${API_URL}/GetDropdown`, reqData);
  }

  //Account List Services
  createMerchantAccount(data: any) {
    return this.apiHttpService.post(`${API_URL}/create-merchant-bank`, {
      ...data,
    });
  }

  getMerchantAccountList(
    pageSize: number = 10,
    page: number = 0,
    filter?: AccountFilter
  ) {
    return this.apiHttpService.post(
      `${API_URL}/get-merchantbank?pageSize=${pageSize}&page=${page}`,
      {
        merchantid: filter?.merchantid || '',
        pageRecords: filter?.pageRecords || 10,
        pageNumber: filter?.pageNumber || 10,
      }
    );
  }

  sendApproval(appObject: any) {
    return this.apiHttpService.post(
      `${API_URL}/ChangeMerchantStatus`,
      appObject
    );
  }

  saveOnboardingRemark(appObject: any) {
    return this.apiHttpService.post(
      `${API_URLBLAZE}/user/merchant/saveOnboardingRemark`,
      appObject
    );
  }

  getTransationList(pageSize: number = 10, page: number = 0, data: any) {
    return this.apiHttpService.post(
      `${API_URL}/Verify-CreateMerchantRecords?pageSize=${pageSize}&page=${page}`,
      data
    );
  }

  getRisk(
    pageSize: number = 10,
    page: number = 0,
    filter?: RiskMerchantFilter
  ) {
    return this.apiHttpService.post(
      `${API_URL}/Verify-CreateMerchantRecords?pageSize=${pageSize}&page=${page}`,
      filter
      // {

      //   "From": filter?.From || "",
      //   "ToDate": filter?.ToDate || "",
      //   "Mid": filter?.Mid || "",
      //   "RiskCode": filter?.RiskCode || "",
      //   "RiskStage": filter?.RiskStage || "",
      //   "RiskFlag": filter?.RiskFlag || "",
      //   "pageRecords": pageSize || 10,
      //   "pageNumber": page || 0,
      // }
    );
  }

  checkAccountExists(accountDetails: any) {
    return this.apiHttpService.post(`${API_URL}/CheckAccountBank`, {
      Product_Id:
        accountDetails?.productId == 'DEFAULT'
          ? ''
          : accountDetails?.productId || '',
      Account: accountDetails?.accountNumber || '',
    });
  }

  getMerchantBYName(data: any) {
    return this.apiHttpService.post(`${API_URL}/GetMerchant`, data);
  }

  // getCategoryType() {
  //   return this.apiHttpService
  //     .get(
  //       `${API_URL}/businessCategory`,
  //     )
  // }

  getCategoryType() {
    return this.apiHttpService.get(
      `${API_URLBLAZE}/user/common/get-business-categories`
      //`http://localhost:8082/user/common/get-business-categories`,
    );
  }

  getSubCategoryType(bid: any) {
    return this.apiHttpService.get(
      `${API_URLBLAZE}/user/common/get-business-sub-categories/` + bid
      //`http://localhost:8082/user/common/get-business-sub-categories/`+bid,
    );
  }

  getBusinessActivities(id?: number | string | null) {
    const lookupId = this.resolveMerchantLookupId(id);
    if (lookupId) {
      return this.apiHttpService.get(`${API_URLBLAZE}/user/merchant-business-activities?id=${lookupId}`);
    }
    return this.apiHttpService.get(`${API_URLBLAZE}/user/business-activities`);
  }

  getActivities(language = 'en') {
    return this.apiHttpService.get(`${API_URLBLAZE}/user/activity/list`, { headers: { 'Accept-Language': language } });
  }

  getSubActivitiesByActivity(activityId: number | string, language = 'en') {
    return this.apiHttpService.get(`${API_URLBLAZE}/user/activity/${activityId}/sub-activities`, { headers: { 'Accept-Language': language } });
  }

  getRiskScore(cat: any, subcat: any) {
    return this.apiHttpService.post(
      `${API_URL}/findRiskCode/${cat}/${subcat}`,
      null
    );
  }
  fetchRemarkList(merchantid: any) {
    return this.apiHttpService.post(
      `${API_URL}/merchant/status/history/${merchantid}`,
      null
    );
  }

  // kyc
  getMerchantKycDetails(businessType: any, id: any) {
    const body = {
      businesstypeId: businessType,
      merchantId: id,
    };
    debugger;
    return this.apiHttpService.post(
      `${API_URLBLAZE}/user/common/kyc-document-list`,
      body
      //`http://localhost:8082/user/common/kyc-document-list`, body
    );
  }

  uploadKycFile(formData: FormData) {
    return this.apiHttpService.post(
      `${API_URLBLAZE}/user/common/upload-image`,
      formData
      //`http://localhost:8082/user/common/upload-image`, formData
    );
  }

  uploadMerchantDocument(formData: FormData) {
    return this.apiHttpService.post(
      `${API_URLBLAZE}/user/files/uploadMerchantDocument`,
      formData
    );
  }

  uploadNewMerchantDocument(formData: FormData) {
    return this.apiHttpService.post(
      `${API_URLBLAZE}/user/files/uploadNewMerchantDocument`,
      formData
    );
  }

  sendWalletOtp(
    payload: {
      mobileNumber: string;
      walletType: string;
      firstName: string;
      lastName: string;
      nationalId: string;
      expirationDate: string;
      userType: string;
    },
    meta: { deviceId: string; latitude: string; longitude: string },
  ) {
    return this.apiHttpService.post(`${API_URLBLAZE}/user/otp`, payload, {
      headers: {
        'Accept-Language': 'fr',
        'x-mobile': payload.mobileNumber,
        'x-device-id': meta.deviceId,
        'x-latitude': meta.latitude,
        'x-longitude': meta.longitude,
      },
    });
  }

  verifyWalletOtp(payload: {
    encKey: string;
    otp: string;
    countryCode: string;
    referenceNo: string;
    userType: string;
      mobileNumber: string;

  }, meta: { deviceId: string; latitude: string; longitude: string }) {
    return this.apiHttpService.postRaw(`${API_URLBLAZE}/user/verify-merchant-otp`, payload, {
      headers: {
        'Accept-Language': 'fr',
        'x-mobile': payload.mobileNumber,
        'x-device-id': meta.deviceId,
        'x-latitude': meta.latitude,
        'x-longitude': meta.longitude,}});
      }


  uploadKycDocsData(merchantId: string, kycDocsData: any[]) {
    const formData = {
      merchantId: merchantId,
      docType: kycDocsData,
    };
    return this.apiHttpService.post(
      `${API_URLBLAZE}/user/common/upload-KycdocsV2`,
      formData
      //`http://localhost:8082/user/common/upload-KycdocsV2`, formData
    );
  }

  downloadKycFile(formData: FormData) {
    return this.apiHttpService.post(
      // `http://localhost:8082/user/common/download-uploadfiles`, formData
      `${API_URLBLAZE}/user/common/download-uploadfiles`,
      formData
    );
  }

  deleteKycFile(formData: any) {
    return this.apiHttpService.post(`${API_URLBLAZE}/user/common/delete-upload-image`, formData);
  }

  deleteAccountDetails(id: any, userId: any) {
    return this.apiHttpService.delete(
      `${API_URLBLAZE}/product/bank/deleteAccountDetails?id=${id}&userId=${userId}`
      // `http://localhost:8086/product/bank/deleteAccountDetails?id=${id}&userId=${userId}`

    );
  }

  getAccountDetails(userId: any) {
    return this.apiHttpService.get(
      `${API_URLBLAZE}/product/bank/accountDetails?userId=${userId}`
      // `http://localhost:8086/product/bank/accountDetails?userId=${userId}`
    );
  }

  saveAccountDetails(formData: any) {
    return this.apiHttpService.post(
      `${API_URLBLAZE}/product/bank/saveAccountDetails`,
      // `http://localhost:8086/product/bank/saveAccountDetails`,
      formData
    );
  }

  validateIban(iban: string) {
    return this.apiHttpService.get(
      `${API_URLBLAZE}/product/bank/validate-iban?iban=${iban}`
      // `http://localhost:8086/product/bank/validate-iban?iban=${iban}`,
    );
  }

  getRiskRemark(mid: any, type: any, apptpye: any) {
    var data = {
      Type: '1',
      ModuleType: type,
      merchant_id: mid,
      AppType: apptpye,
    };
    return this.apiHttpService.post(API_URL + '/GetRemarks', data);
  }

  getOnboardingRemark(userId: any, appType: any) {
    return this.apiHttpService.get(
      `${API_URLBLAZE}/user/merchant/getOnboardingRemark?userId=${userId}&appType=${appType}`
      // `http://localhost:8082/user/merchant/getOnboardingRemark?userId=${userId}&appType=${appType}`
    );
  }

  getMerchantContractPdf(mobileNumber: any) {
    return this.apiHttpService.get(
      `${API_URLBLAZE}/user/merchant/contract-pdf?mobileNumber=${mobileNumber}`,
      {
        observe: 'response',
        responseType: 'blob',
      }
    );
  }
  getHtmlFile(filePath: string): Promise<string> {
    return this.apiHttpService
      .get(filePath, { responseType: 'text' })
      .toPromise();
  }

  getLeadReport1() {
    return this.apiHttpService.get(`${API_URL1}/masterList`);
  }

  getMerchantStaticQR(payload: any) {
    return this.apiHttpService.post(`${API_URLBLAZE}/transaction/transact/generate-qr`, payload);
  }

  validateTrade(tradeRequest: any) {
    const url = `${API_URLBLAZE}/user/check-trade`;
    // const url = `http://localhost:8082/user/check-trade`;
    return this.apiHttpService
      .post(url, tradeRequest)
      .pipe(catchError(this.handleError()));
  }

  getLeadReport(page: number, pageSize: number) {
    return this.apiHttpService.get(
      `${API_URL1}/masterList/${page}/${pageSize}`
    );
  }
  getLeadReportByMobileEmail(model: any, page: number, pageSize: number) {
    return this.apiHttpService.post(
      `${API_URL1}/masterListFilter/${page}/${pageSize}`,
      model
    );
  }

  saveRemark(activityData: any) {
    const url = `${API_URLBLAZE}/user/screening/activityTime`;
    return this.apiHttpService
      .post(url, activityData)
      .pipe(catchError(this.handleError()));
  }

  getRemarkById(id: any) {
    const url = `${API_URLBLAZE}/user/screening/activityTime/` + id;
    return this.apiHttpService.get(url).pipe(catchError(this.handleError()));
  }

  //UBO
  saveUBO(uboData: any) {
    return this.apiHttpService.post(
      `${API_URLBLAZE}/user/merchant/saveUBO`,
      uboData
    );
  }

  getUBO(userId: any) {
    return this.apiHttpService.get(
      `${API_URLBLAZE}/user/merchant/getUBO/${userId}`
    );
  }

  deleteUBO(id: any) {
    return this.apiHttpService.delete(
      `${API_URLBLAZE}/user/merchant/deleteUBO/${id}`
    );
  }

  deleteUBODocument(id: any, fileName: any) {
    return this.apiHttpService.delete(
      `${API_URLBLAZE}/user/merchant/deleteUBODocument/${id}?fileName=${fileName}`
    );
  }

  submitUBOForScreening(userId: any) {
    return this.apiHttpService.post(
      `${API_URLBLAZE}/user/merchant/submitUBO/${userId}`,
      null
    );
  }

  //RESELLER COMMISSION CONFIGURATION
  getResellerConfiguration(entityid: any) {
    return this.apiHttpService.get(

      //`http://localhost:8083/transaction/commission/reseller/${entityid}`
      `${API_URLBLAZE}/transaction/commission/reseller/${entityid}`
    );
  }

  getConstantConfiguration(feeType: any) {
    return this.apiHttpService.get(

       `${API_URLBLAZE}/transaction/commission/constant/${feeType}`
      //`http://localhost:8083/transaction/commission/constant/${feeType}`
    );
  }

  //COMMISSION CONFIGURATION
  saveConfiguration(commissionData: any) {
    return this.apiHttpService.post(

      `${API_URLBLAZE}/transaction/commission/save`,
      //`http://localhost:8083/transaction/commission/save`,
      commissionData
    );
  }

  updateConfiguration(commissionData: any) {
    return this.apiHttpService.post(

      `${API_URLBLAZE}/transaction/commission/update`,
      //`http://localhost:8083/transaction/commission/update`,
      commissionData
    );
  }


  getResellerMerchantDetails(merchantId: any) {
    return this.apiHttpService.get(

      `${API_URLBLAZE}/user/merchant/getResellerMerchantDetails/${merchantId}`
      //`http://localhost:8082/user/merchant/getResellerMerchantDetails/${merchantId}`
    );

  }

  getConfiguration(userId: any) {
    return this.apiHttpService.get(

      `${API_URLBLAZE}/transaction/commission/${userId}`
     // `http://localhost:8083/transaction/commission/${userId}`
    );
  }

  updateMaxValue(entityId: string, toAmountMaxValue: number, type: string) {
    return this.apiHttpService.post(
      `${API_URLBLAZE}/transaction/commission/updateMaxValue?entityId=${entityId}&toAmountMaxValue=${toAmountMaxValue}&type=${type}`,
      {}
    );
  }

  resetConfiguration(entityId: string, type: string, userType: string) {
    return this.apiHttpService.post(
      `${API_URLBLAZE}/transaction/commission/reset?entityId=${entityId}&type=${type}&userType=${userType}`,
      {}
    );
  }

  // POS DEVICE
  getDeviceList(userId: any) {
    return this.apiHttpService.get(
      `${API_URLBLAZE}/terminal/device/list/${userId}`
    );
  }

  getPOSImage(logoLink: any) {
    const url = `${logoLink}`;
    return this.apiHttpService
      .get(url, { responseType: 'blob' as 'json' })
      .pipe(catchError(this.handleError()));
  }

  // PG URL
  getPgBusinessTypeList() {
    return this.apiHttpService.get(
      `${API_URLPG}crm-merchant-setup/fetchBusinessList`
    );
  }

  getPgMerchantAccountList(businessType: string, email: string) {
    return this.apiHttpService.get(
      `${API_URLPG}crm-merchant-setup/fetchMerchantList/${businessType}/${email}`
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      if (error.status == 401) {
        this.storageService.clean();
        this.router.navigate(['/auth/login']);
      }
      result = error?.error;
      return of(result as T);
    };
  }

  sendMerchantDecisionNotification(merchant: any) {
    return this.apiHttpService.post(
      `${API_URL}/user/merchant/push-notification`,
        merchant
    );
  }

  pushContractNotification(merchant: any) {
    return this.apiHttpService.post(
      `${API_URL}/user/merchant/push-contract-notification`,
        merchant
    );
  }
}
